import { useMemo } from "react";
import { useFeatures } from "./features";

export function useFeatureGate(featureName: string) {
  const { data: features, isPending, isPlaceholderData } = useFeatures();

  return useMemo(
    () => ({
      settled: !isPending && !isPlaceholderData,
      enabled:
        features?.find((feature) => featureName === feature.name)?.enabled ||
        false,
    }),
    [features, featureName, isPending, isPlaceholderData],
  );
}
